import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectInput from "../SelectInput/index";
import AddInput from "../AddInput/index";
import { updateConfig, listConfig, getNetworkInfo } from '@/api/configurationlist';
import addTable from "./components/addTable";
import editDialog from "./components/editDialog";
import { cloneDeep, isEqual } from 'lodash'; // import networkInfo from '../networkInfo/index'

export default {
  props: ["deviceDid", "deviceSn"],
  data: function data() {
    return {
      protocolList: [{
        value: 'tcp udp',
        label: 'ALL'
      }, {
        value: 'tcp',
        label: 'TCP'
      }, {
        value: 'udp',
        label: 'UDP'
      }, {
        value: 'other',
        label: this.$t('lang.port.other')
      }],
      wanList: [{
        value: 'wan',
        label: 'wan'
      }],
      lanList: [{
        value: 'lan',
        label: 'lan'
      }],
      centerDialogVisible: false,
      //弹出框数据
      DialogFromData: {},
      index: null,
      enabled: false,
      IpList: [],
      deleteOptions: [],
      // 记录长度
      rLength: 0,
      // 网络接口基本信息
      networkInfo: {},
      portData: [],
      loading: false,
      copyData: []
    };
  },
  components: {
    SelectInput: SelectInput,
    AddInput: AddInput,
    addTable: addTable,
    editDialog: editDialog // networkInfo

  },
  mounted: function mounted() {
    var _this = this;

    //获取下拉ip列表
    listConfig(this.deviceSn, this.deviceDid, [{
      section: 'arp',
      config: 'arp'
    }]).then(function (res) {
      _this.IpList = res.data.data.mess[0].s_objects.map(function (val) {
        return {
          value: val.ipaddr,
          label: "".concat(val.ipaddr, " (").concat(val.macaddr, ")")
        };
      });

      _this.IpList.push({
        value: '自定义',
        label: _this.$t('lang.ConfigSetting.custom')
      });

      _this.IpList.push({
        value: '',
        label: _this.$t('lang.firewall.all')
      });
    });
    this.getConfig();
  },
  methods: {
    // 获取配置信息
    getConfig: function getConfig() {
      var _this2 = this;

      this.loading = true;
      this.portData = [];
      listConfig(this.deviceSn, this.deviceDid, [{
        section: "redirect",
        config: "firewall",
        options: [{
          option: "target"
        }, {
          option: "dest"
        }, {
          option: "proto"
        }, {
          option: "src_dport"
        }, {
          option: "extzone"
        }, {
          option: "dest_ip"
        }, {
          option: "dest_port"
        }, {
          option: "name"
        }, {
          option: "enabled"
        }, {
          option: "src_ip"
        }, {
          option: "src_port"
        }, {
          option: "src_dip"
        }, {
          option: "src_dport"
        }, {
          option: "reflection"
        }, {
          option: "extra"
        }, {
          option: "extport"
        }, {
          option: "intport"
        }, {
          option: "src"
        }]
      }]).then(function (res) {
        _this2.rLength = res.data.data.mess[0].s_objects.length;
        res.data.data.mess[0].s_objects.forEach(function (item, index) {
          var itemObj = item;

          _this2.$set(itemObj, 'index', index);

          if (item.options.target != 'SNAT' && !['dmz_tcp_ports1', 'dmz_tcp_ports2', 'dmz_tcp_ports3'].includes(item.options.name)) {
            itemObj.options.enabled = itemObj.options.enabled == '0' ? false : true;

            _this2.portData.push(itemObj);
          }
        });
        _this2.copyData = cloneDeep(_this2.portData);
        _this2.loading = false;
      }).catch(function (err) {
        _this2.$message({
          message: _this2.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    //新建端口转发
    newdata: function newdata(index) {
      this.portData.push({
        action: 1,
        options: {
          src_dip: "",
          reflection: "",
          dest: "lan",
          src: 'wan',
          enabled: "",
          target: "DNAT",
          src_ip: "",
          src_port: "",
          src_dport: "",
          proto: "tcp udp",
          dest_ip: "",
          extra: "",
          name: "Forward",
          dest_port: "",
          extzone: ''
        }
      });
    },
    //启用禁用
    OnOff: function OnOff() {
      this.DialogFromData.enabled = this.DialogFromData.enabled == '' ? true : false;
    },
    // 更新并应用
    updateRedirect: function updateRedirect() {
      var _this3 = this;

      if (!isEqual(this.copyData, this.portData)) {
        var data = [];
        this.portData.forEach(function (item, index) {
          if (item.action == undefined) {
            _this3.portData[index].action = 0;
          }

          var options = cloneDeep(item.options);

          if (options.enabled) {
            options.enabled = '1';
          } else {
            options.enabled = '0';
          }

          data.push({
            section: "redirect",
            config: "firewall",
            action: item.action,
            index: [item.index],
            server: "firewall",
            options: options
          });
        });
        this.deleteOptions.forEach(function (item, index) {
          var options = cloneDeep(item.options);

          if (options.enabled) {
            options.enabled = '1';
          } else {
            options.enabled = '0';
          }

          data.push({
            section: "redirect",
            config: "firewall",
            action: item.action,
            index: [item.index],
            server: "firewall",
            options: options
          });
        });
        updateConfig(this.deviceSn, this.deviceDid, data).then(function (res) {
          if (res.data.data.mess === 0) {
            _this3.$message({
              showClose: true,
              message: _this3.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: 'success'
            });

            _this3.deleteOptions = [];

            _this3.getConfig();
          } else {
            _this3.$message({
              showClose: true,
              message: _this3.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });

            return;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return;
      }
    },
    // 更新数据
    updateData: function updateData() {
      this.getConfig();
    },
    // 删除数据
    deleteRedirect: function deleteRedirect(row, index) {
      if (row.action == undefined) {
        // 不是后来添加的数据,若是原来的数据则保存到待删除数组中
        this.deleteOptions.push({
          index: row.index,
          options: row.options,
          sname: row.sname,
          action: 2
        }); // 在列表中删除

        this.portData.splice(index, 1);
      } else {
        // 不然直接在列表中删除即可
        this.portData.splice(index, 1);
      }
    },
    // 添加端口转发
    addRedirect: function addRedirect(value) {
      var redirectObj = value;
      redirectObj.index = this.rLength;
      this.rLength = this.rLength + 1;
      this.portData.push(redirectObj);
    },
    // 编辑端口转发
    editRedirect: function editRedirect(row) {
      this.$refs.editDialog.show(row.options, row.index);
    }
  }
};